module.exports = __webpack_public_path__ + "static/media/basic-adaption.e3e719c4.png";